module.exports = __webpack_public_path__ + "static/media/icon_specs-water.727d9cd1.svg";